import { z } from 'zod';

// A Conversation is gateway runtime state: the bridge from an external channel thread to the
// reused agent Session that backs it. Resolving (binding, surface, externalThreadRef) → one
// Session keeps a thread's whole history in that Session's append-only transcript, so context
// is never re-sent. Not an admin/wire read model — observability is a later Agent Admin concern.

// The reply surface. A fan-out-on-own-media-comment binding spawns two conversations per comment (a
// public comment_thread reply + a dm), so surface is part of the thread identity. Tuple
// exported so the Drizzle column enum reuses it and can never drift. `support_thread` is a
// help-desk conversation (Intercom), where the reply is an internal note a human sends on.
// `channel_thread` is a thread inside a chat channel (Slack), keyed `<channel id>:<root ts>`.
export const SURFACES = ['comment_thread', 'dm', 'support_thread', 'channel_thread'] as const;
export const SurfaceSchema = z.enum(SURFACES);
export type Surface = z.infer<typeof SurfaceSchema>;

export const ConversationSchema = z.object({
  id: z.uuid(),
  channelBindingId: z.uuid(), // FK → ChannelBinding (owns the agent + version + strategy)
  surface: SurfaceSchema,
  externalThreadRef: z.string(), // the channel's thread/comment id the webhook carries
  sessionId: z.uuid(), // the reused agent Session this thread is backed by
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type Conversation = z.infer<typeof ConversationSchema>;
